export enum ConnectProgramEnum {
  CONSTELLATION_DINNERS = 'Constellation Dinners',
  SUPERNOVA_DINNERS = 'Supernova Dinners',
  AURORA_DINNERS = 'Aurora Dinners',
  GALAXY_DINNERS = 'Galaxy',
  SLACK = 'Slack',
  NEBULA_DINNERS = 'Nebula Dinners',
}
